const media = [
  { src: "/media/gameplay-fleet.png", alt: "A fleet of dinghies, a speedboat, and an overloaded raft approaching the beach" },
  { src: "/media/gameplay-yeet.png", alt: "A refugee mid-flight back out to sea, splash and combo text visible" },
  { src: "/media/gameplay-menu.png", alt: "Rapid Refugees start menu" },
];

export function renderStore(app: HTMLElement): void {
  app.innerHTML = `
    <div class="steam-page">
      <header class="steam-global-header">
        <div class="steam-global-inner">
          <a class="steam-logo" href="/store"><i></i><span>STEAM</span></a>
          <nav aria-label="Steam navigation">
            <a class="active" href="#">STORE</a><a href="#">COMMUNITY</a><a href="#">ABOUT</a><a href="#">SUPPORT</a>
          </nav>
          <div class="steam-account"><span>Install Steam</span> login&nbsp; | &nbsp;language</div>
        </div>
      </header>
      <div class="store-body">
        <nav class="steam-store-nav" aria-label="Store categories">
          <a href="#">Your Store</a><a href="#">New &amp; Noteworthy</a><a href="#">Categories</a><a href="#">Points Shop</a><a href="#">News</a><a href="#">Labs</a>
          <label><span class="sr-only">Search</span><input value="search the store" readonly><b>⌕</b></label>
        </nav>
        <main class="steam-content">
          <div class="steam-breadcrumb">All Games &gt; Indie Games &gt; Rapid Refugees</div>
          <div class="steam-title-row"><h1>Rapid Refugees</h1><a href="/">Community Hub</a></div>

          <section class="steam-hero">
            <div class="steam-gallery">
              <div class="steam-main-media"><img id="store-main-media" src="${media[0]?.src}" alt="${media[0]?.alt}"></div>
              <div class="steam-thumbnails">
                ${media.map((item, index) => `<button class="${index === 0 ? "active" : ""}" data-media="${index}" aria-label="Show screenshot ${index + 1}"><img src="${item.src}" alt=""></button>`).join("")}
              </div>
            </div>
            <aside class="steam-summary">
              <img class="steam-capsule" src="/media/key-art.svg" alt="Rapid Refugees key art">
              <p>The coast is clear — let's keep it that way. Intercept the dinghies, grab the passengers mid-crossing, and return them to sender at terminal velocity.</p>
              <dl>
                <dt>RECENT REVIEWS:</dt><dd>Overwhelmingly Positive <small>(1,337)</small></dd>
                <dt>ALL REVIEWS:</dt><dd>Very Positive <small>(4,204)</small></dd>
                <dt>RELEASE DATE:</dt><dd>3 Aug, 2026</dd>
                <dt>DEVELOPER:</dt><dd>Racial Detour</dd>
                <dt>PUBLISHER:</dt><dd>Shitgate Interactive</dd>
              </dl>
              <div class="steam-tags"><span>Physics</span><span>Dark Humor</span><span>Arcade</span><span>Score Attack</span><span>Satire</span></div>
            </aside>
          </section>

          <div class="steam-columns">
            <div class="steam-main-column">
              <section class="steam-buy-box">
                <h2>Play Rapid Refugees</h2>
                <p>Includes the full coastline and unlimited deportations</p>
                <div class="steam-buy-action"><span>Free To Play</span><a href="/">Play Game</a></div>
              </section>
              <button id="wishlist-button" class="wishlist-button">♡ Add to your wishlist</button>

              <article class="steam-panel steam-about">
                <h2>ABOUT THIS GAME</h2>
                <img src="/media/about-banner.svg" alt="One beach. One buoy line. Unlimited returns.">
                <h3>Every boat is a high score waiting to happen.</h3>
                <p><strong>Rapid Refugees</strong> is a precision physics score attack about hands-on coastal border management. Dinghies, speedboats, and catastrophically overloaded rafts are making the crossing toward your beach. Grab passengers straight out of the boats, wind up, and yeet them back into open water. The further they fly, the louder the splash, the bigger the points.</p>
                <p>Short throws barely clear the surf and score nothing. Three landings and the beach is overrun. Combo streaks reward a firm, consistent deportation arm.</p>
                <div class="feature-grid">
                  <div><b>3</b><span>boat classes</span></div>
                  <div><b>1</b><span>buoy line</span></div>
                  <div><b>∞</b><span>return tickets</span></div>
                </div>
                <h3>Built for one more patrol</h3>
                <ul>
                  <li>Grab-drag-release throwing with real velocity transfer</li>
                  <li>Distance-based scoring past the buoy line, with combo multipliers</li>
                  <li>Dinghies, speedboats, and hopelessly overloaded rafts</li>
                  <li>Splash particles, panic screams, and screen shake on big yeets</li>
                  <li>Three-strike fail state and persistent local best scores</li>
                  <li>Fully responsive mouse, pen, and touchscreen controls</li>
                </ul>
              </article>

              <article class="steam-panel">
                <h2>EARLY PLAYER REVIEWS</h2>
                <div class="review-card">
                  <div class="review-author"><b>Bart</b><span>1.2 hrs on record</span></div>
                  <div class="review-copy"><div>👍 Recommended</div><time>POSTED: 3 AUGUST</time><p>“the PLAY button works AND the refugees don't. 10/10”</p></div>
                </div>
                <div class="review-card">
                  <div class="review-author"><b>FrontexFan92</b><span>6.1 hrs on record</span></div>
                  <div class="review-copy"><div>👍 Recommended</div><time>POSTED: 3 AUGUST</time><p>“came for the physics, stayed for the splash sound. my throwing arm needs a union.”</p></div>
                </div>
                <div class="review-card">
                  <div class="review-author"><b>BabyPowderDistributor</b><span>0.7 hrs on record</span></div>
                  <div class="review-copy"><div>👍 Recommended</div><time>POSTED: 3 AUGUST</time><p>“somehow more ethical than my day job. LMAOOO”</p></div>
                </div>
              </article>

              <article class="steam-panel mature-panel">
                <h2>MATURE CONTENT DESCRIPTION</h2>
                <p>The developers describe the content like this:</p>
                <blockquote>Contains cartoon slapstick and dark political satire involving stylized human characters being thrown into the sea. No blood, gore, or realistic injury is depicted. No refugees were harmed; several were mildly inconvenienced.</blockquote>
              </article>
            </div>

            <aside class="steam-sidebar">
              <section class="steam-side-card feature-list">
                <a href="/"><i>▣</i> Single-player</a>
                <a href="/"><i>🏆</i> Personal bests</a>
                <a href="/"><i>☁</i> Local save data</a>
                <a href="/"><i>☝</i> Touch friendly</a>
                <a href="/"><i>⛶</i> Fullscreen</a>
              </section>
              <section class="steam-side-card">
                <h3>Is this game relevant to you?</h3>
                <p>Sign in to see reasons why you may or may not like this based on your games, friends, and curators you follow.</p>
              </section>
              <section class="steam-side-card language-card">
                <h3>Languages</h3>
                <table><thead><tr><th></th><th>Interface</th><th>Audio</th><th>Subtitles</th></tr></thead><tbody><tr><td>English</td><td>✔</td><td></td><td>✔</td></tr></tbody></table>
              </section>
              <section class="steam-side-card rating-card">
                <div class="rating-badge">18</div><p>Dark humor<br>Cartoon violence<br>Aggressive repatriation</p>
              </section>
              <section class="steam-side-card details-card">
                <p><b>Title:</b> Rapid Refugees</p><p><b>Genre:</b> Casual, Indie, Satire</p><p><b>Developer:</b> <a href="#">Racial Detour</a></p><p><b>Publisher:</b> <a href="#">Shitgate Interactive</a></p><p><b>Release Date:</b> 3 Aug, 2026</p>
              </section>
              <section class="steam-side-card links-card"><a href="/">Visit the website ↗</a><a href="#">View update history</a><a href="#">Read related news</a><a href="#">View discussions</a></section>
            </aside>
          </div>
          <footer class="steam-footer">Storefront concept for Rapid Refugees · Steam and the Steam logo are trademarks of Valve Corporation.</footer>
        </main>
      </div>
    </div>
  `;

  const mainMedia = app.querySelector<HTMLImageElement>("#store-main-media");
  const thumbnailButtons = [...app.querySelectorAll<HTMLButtonElement>("[data-media]")];
  for (const button of thumbnailButtons) {
    button.addEventListener("click", () => {
      const index = Number(button.dataset.media);
      const item = media[index];
      if (!item || !mainMedia) return;
      mainMedia.src = item.src;
      mainMedia.alt = item.alt;
      thumbnailButtons.forEach((candidate) => candidate.classList.toggle("active", candidate === button));
    });
  }

  app.querySelector("#wishlist-button")?.addEventListener("click", (event) => {
    const button = event.currentTarget as HTMLButtonElement;
    const selected = button.classList.toggle("selected");
    button.textContent = selected ? "✓ On your wishlist" : "♡ Add to your wishlist";
  });
}
